export default __webpack_public_path__ + "static/media/page.c2f68ee4.webp";